import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from '@angular/common/http';
import { Global } from './classes/Global';

@Injectable()
export class CardDealService extends BaseService{

  public apiUrl = "CardDeal.php?";

  constructor(
    protected http: HttpClient,
  ) {
      super(http);
  }

  create(sessionToken: string, country: string, store: string, title: string, notes: string,
    link: string, source: string, price: string, cardValue: string, shippingType: string) {
      const url = this.serverUrl + this.apiUrl;
      const params = this.buildUrlParams(
        new UrlParam("action", "create"),
        new UrlParam("sessionToken", sessionToken),
        new UrlParam("country", country),
        new UrlParam("store", store),
        new UrlParam("title", title),
        new UrlParam("notes", notes),
        new UrlParam("link", link),
        new UrlParam("source", source),
        new UrlParam("price", price),
        new UrlParam("cardValue", cardValue),
        new UrlParam("shippingType", shippingType),
        new UrlParam("origin", "website"),
        new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  getDeal(sessionToken: string, country: string, store: string, id: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "get"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

  remove(sessionToken: string, country: string, store: string, id: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "remove"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

  addComment(sessionToken: string, country: string, store: string, id: string, text: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("action", "addComment"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("text", text),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  addCommentToComment(sessionToken: string, country: string, store: string, id: string, text: string, commentId: Number) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("action", "addCommentToComment"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("text", text),
      new UrlParam("commentId", commentId.toString()),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.post(url, params);
  }

  removeComment(sessionToken: string, country: string, store: string, id: string, commentId: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "removeComment"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("commentId", commentId),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

  getDeals(country: string, store: string, shippingType: string, limit: number, offset: number, sessionToken: string) {
    
    let params = this.buildUrlParams(
      new UrlParam("action", "getDeals"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("shippingType", shippingType),
      new UrlParam("limit", limit.toString()),
      new UrlParam("offset", offset.toString()),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );

    if(sessionToken) {
      params += this.addUrlParam(new UrlParam("sessionToken", sessionToken));
    }
    
    const url = this.serverUrl + this.apiUrl + params;
    return this.get(url);
  }

  reportExpired(sessionToken: string, country: string, store: string, id: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "reportExpired"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

  upvote(sessionToken: string, country: string, store: string, id: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "doUpvote"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("vote", "1"),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

  downvote(sessionToken: string, country: string, store: string, id: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "doDownvote"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("id", id),
      new UrlParam("vote", "-1"),
      new UrlParam("origin", "website"),
      new UrlParam("appEntity", Global.APP_ENTITY_MAIN_WEBSITE)
    );
    return this.get(url);
  }

}
